import { render, staticRenderFns } from "./index-icon.vue?vue&type=template&id=3eadc5d4"
import script from "./index-icon.vue?vue&type=script&lang=js"
export * from "./index-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports